import { BadgeV3, TooltipV2 } from '@cimplico/components';
import { SparklesIcon } from '@heroicons/react/20/solid';
import { CheckBadgeIcon, ChevronLeftIcon } from '@heroicons/react/24/solid';
import { ReactNode } from 'react';
import CommingSoon from '../coming-soon/CommingSoon';

type IntegrationOverviewProps = {
    logo: string;
    title: string;
    description: string;
    active: boolean;
    children?: ReactNode | ReactNode[];
    sideContent?: { label: string; value: string; tooltip?: string }[];
    supportLink?: string;
    comingSoon?: boolean;
    onBack?: () => void;
    beta?: boolean;
    _new?: boolean;
};

function IntegrationOverview({
    logo,
    title,
    description,
    active,
    children,
    sideContent = [],
    supportLink,
    comingSoon = false,
    onBack,
    beta = false,
    _new = false,
}: IntegrationOverviewProps): JSX.Element {
    return (
        <div className="grid grid-cols-[200px_auto]">
            <div className={onBack ? 'pt-8 relative' : ''}>
                {onBack && (
                    <button className="text-sm text-gray-600 flex items-center gap-1 absolute w-fit top-0" onClick={onBack}>
                        <ChevronLeftIcon className="h-4 w-4" />
                        Integrations
                    </button>
                )}
                <div className="w-max border-b pb-4">
                    <img src={logo} className="h-24 w-24" />
                    <div className="mt-2 mx-auto w-fit">
                        {active ? (
                            <BadgeV3 size="small" rounded={false} color="green" label="Active" />
                        ) : (
                            <BadgeV3 size="small" rounded={false} color="red" label="Inactive" />
                        )}
                    </div>
                </div>
                <div className="text-sm text-gray-700 mt-4">
                    {sideContent.length > 0 && active && (
                        <div>
                            {sideContent.map((sc) => {
                                return (
                                    <div key={sc.label} className="w-fit">
                                        <p className="font-medium">{sc.label}</p>
                                        {sc.tooltip ? (
                                            <TooltipV2 message={sc.tooltip}>
                                                <p className="mb-2">{sc.value}</p>
                                            </TooltipV2>
                                        ) : (
                                            <p className="mb-2">{sc.value}</p>
                                        )}
                                    </div>
                                );
                            })}
                        </div>
                    )}
                    <a className="text-indigo-600" href={supportLink || 'https://support.cimplico.com'} target="_blank" rel="noreferrer">
                        Setup Guide
                    </a>
                </div>
            </div>
            <div>
                <div className="flex items-center gap-2">
                    <h2 className="text-3xl font-medium text-gray-900">{title}</h2>
                    {beta && <BadgeV3 size="small" rounded={false} color="indigo" label="Beta" />}
                    {_new && <BadgeV3 size="small" rounded={false} color="indigo" label="New" leftIcon={<SparklesIcon />} />}
                </div>

                <p className="text-gray-600 text-sm mb-4">{description}</p>
                <label className="flex items-center text-sm text-gray-700">
                    By
                    <a className="text-indigo-600 ml-1" href="https://www.cimplico.com" target="_blank" rel="noreferrer">
                        Cimplico
                    </a>
                    <CheckBadgeIcon className="text-indigo-600 h-5 w-5 ml-1" />
                </label>
                <div>
                    {comingSoon ? (
                        <div className="w-fit mx-auto">
                            <CommingSoon size="small" />
                        </div>
                    ) : (
                        children
                    )}
                </div>
            </div>
        </div>
    );
}
export default IntegrationOverview;
